import APP_ERROR from '../constants/appErrors';

const getErr = APP_ERROR;

class HandleResponses {
  static Status(result) {
    let text = '';
    const status = result.status;
    const { code, data, message, field } = (result.data && result.data.errors) ? result.data.errors[0] : { };
    switch (status) {
      case 204:
        return { success: 'OK' };
      case 400:
        if (code && data && data.length) {
          text = getErr[code] + data.toString();
        } else if (code && getErr[code]) {
          text = getErr[code];
        } else if (message) {
          text = `${message} - ${getErr.VALIDATION_FAILS}`;
        } else {
          text = getErr['400'];
        }
        return { error: text };

      case 401:
      case 403:
        if (result.data.error) {
          return result.data;
        }
        if (result.data.errors && result.data.errors[0] && result.data.errors[0].message) {
          return { error: result.data.errors[0].message };
        }
      case 404:
      case 500:
      case 503:
        return { error: getErr[status.toString()] };

      case 409:
        return { error: message };

      default:
        return { error: getErr.GENERAL_ERR };
    }
  }
}

export default HandleResponses;
